import { t } from "components/CentralDataMangement/translation/Translation";
import Title from "components/common/atoms/Title";
import OfficeTargetTable from "../common/OfficeTargetTable";
import {
  CooAgreementDetails,
  OMTargetAchievedData,
  OfficeTarget,
  ProspectCallDetails,
  StarterDetails,
  StopperDetails,
  VacancyDetails,
  VisitsDetails,
} from "../Annotations";
import { useEffect, useMemo, useState } from "react";
import OMTargetTable from "../common/OMTargetTable";
import VacanciesTable from "../common/VacanciesTable";
import VisitsTable from "../common/VisitsTable";
import CooAgreementTable from "../common/CooAgreementTable";
import ProspectCallsTable from "../common/ProspectCallsTable";
import TableTitle from "components/common/atoms/TableTitle";
import StartersTable from "../common/StartersTable";
import StoppersTable from "../common/StoppersTable";
import LabelWithTextAreaField from "components/common/molecules/LabelWithTextAreaField";
// import secureLocalStorage from "react-secure-storage";
import EncryptDecryptService from "components/common/services/EncryptDecryptService";
import CustomNotify from "components/common/atoms/CustomNotify";
import { ApiCall } from "components/common/services/ApiServices";
import { EDIT_MONTHLY_REPORTS, UPDATE_MONTHLY_REPORTS } from "../../../../routes/ApiEndpoints";
import { ACCOUNT_MANAGER, ADMIN, AREA_MANAGER, CENTRAL_DATA_MANAGEMENT_MICROSERVICE, OFFICE_MANAGER, SUPER_ADMIN } from "Constants";
import LoadingIcon from "components/common/utlis/LoadingIcon";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import Button from "components/common/atoms/Button";
import { useSelector } from "react-redux";
import { selectAuth } from "features/auth/AuthSlice";
import ValidationDetails from "../common/ValidationDetails";
import AccessControl from "components/common/services/RolesAndPermissions/AccessControl";

interface TargetData {
  officeQTarget: OfficeTarget;
  officeTarget: OfficeTarget;
  targets: OMTargetAchievedData;
}

interface ReportsData {
  periodId: number | null;
  vacancies: VacancyDetails[];
  foreignVacancies: VacancyDetails[];
  visits: VisitsDetails[];
  cooAgreement: CooAgreementDetails[];
  prospectCalls: ProspectCallDetails[];
  starters: StarterDetails[];
  stoppers: StopperDetails[];
  from?: string | null;
  to?: string | null;
  amName?: string;
}

interface Analysis {
  analysis: string;
  smile_moments: string;
  growth_points: string;
  thoughts_comments: string;
  om_analysis: string;
  om_name: string;
  om_confirmed_at: string | null;
  am_analysis: string;
  am_name: string;
  am_confirmed_at: string | null;
  confirmed_at: string | null;
}

const MonthlyReports: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [targetData, setTargetData] = useState<TargetData>();
  const navigate = useNavigate();
  const [reports, setReports] = useState<ReportsData>({
    periodId: null,
    vacancies: [],
    foreignVacancies: [],
    visits: [],
    prospectCalls: [],
    cooAgreement: [],
    starters: [],
    stoppers: []
  });
  const [analysisData, setAnalysisData] = useState<Analysis>({
    analysis: "",
    smile_moments: "",
    growth_points: "",
    thoughts_comments: "",
    am_analysis: "",
    om_analysis: "",
    om_name: "",
    om_confirmed_at: null,
    am_name: "",
    am_confirmed_at: null,
    confirmed_at: null
  });

  const authUser = useSelector(selectAuth);
  // let data = secureLocalStorage.getItem('omMonthlyReport') as string; // Get the 'data' query param as a string
  const [searchParams] = useSearchParams();
  const data = searchParams.get("data");
  useEffect(() => {
    const timeout = setTimeout(() => {
      fetchData();
    }, 3000); // 3 seconds

    return () => clearTimeout(timeout); // Cleanup the timeout on component unmount
  }, []);

  const fetchData = async () => {
    let parsedData = {};
    try {
      if (data) {
        // Decrypt the recruiterData
        let decryptedData = decodeURIComponent(EncryptDecryptService.decryptData(data));

        // If decryptedData is in JSON format, parse it
        parsedData = JSON.parse(decryptedData);
      }

    } catch (error) {
      CustomNotify({
        type: "error",
        message: t("Something went wrong"),
      });
      setLoading(false);
      return null;
    }

    const response = await ApiCall.service(
      EDIT_MONTHLY_REPORTS,
      "POST",
      { ...parsedData, type: "accountManager" },
      false,
      CENTRAL_DATA_MANAGEMENT_MICROSERVICE
    );

    if (response?.status === 200) {
      setTargetData((prevData) => (response?.data?.targetData));
      setReports(response?.data?.reportTypes);
      if (response?.data?.analysis) {
        setAnalysisData(response?.data?.analysis);
      }
    }else{
      CustomNotify({
        type: "error",
        message: "Some error occured"
      });
    }
    setLoading(false);
  }
  const foreignOffice = targetData?.officeQTarget?.isForeign

  const handleAnalysisFieldChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.target as HTMLInputElement;

    setAnalysisData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e: React.FormEvent, isValidate: boolean = false) => {
    e.preventDefault();
    setLoading(true);

    let parsedData = {};
    try {
      if (data) {
        // Decrypt the recruiterData
        let decryptedData = decodeURIComponent(EncryptDecryptService.decryptData(data));

        // If decryptedData is in JSON format, parse it
        parsedData = JSON.parse(decryptedData);
      }

    } catch (error) {
      CustomNotify({
        type: "error",
        message: t("Something went wrong"),
      });
      setLoading(false);
      return null;
    }

    const payload = {
      type: "accountManager",
      periodId: reports?.periodId,
      analysis: analysisData,
      isValidate: isValidate,
      reportData: { ...parsedData, type: "accountManager" }
    };

    const url = UPDATE_MONTHLY_REPORTS;
    const response = await ApiCall.service(
      url,
      "POST",
      payload,
      false,
      CENTRAL_DATA_MANAGEMENT_MICROSERVICE
    );
    if (response?.status === 200) {
      CustomNotify({ type: "success", message: response?.msg });
      navigate("/manage-reports");
    } else {
      CustomNotify({ type: "error", message: t("Something went wrong") })
    }
    setLoading(false);
  };

  const isCurrentMonth = useMemo(() => {
    try {
      if (!data) return false;
      const parsedData = JSON.parse(decodeURIComponent(EncryptDecryptService.decryptData(data)));
      const now = new Date();
      return Number(parsedData.periodNumber) === (now.getMonth() + 1) && Number(parsedData.year) === now.getFullYear();
    } catch {
      return false;
    }
  }, [data]);

  // Each role owns one part of the report and may fill it in until it has validated its own part:
  // the account manager the analysis (confirmed_at), the office manager its feedback
  // (om_confirmed_at) and the area manager its feedback (am_confirmed_at). Deliberately not
  // chained on the previous role's validation, so feedback can be written while the report is
  // still being completed; the validation stamps record who signed off and when.
  const canAct = () => {
    if (authUser.role === ACCOUNT_MANAGER && !analysisData?.confirmed_at) {
      return true;
    } else if (authUser.role === OFFICE_MANAGER && !analysisData?.om_confirmed_at) {
      return true;
    } else if (authUser.role === AREA_MANAGER && !analysisData?.am_confirmed_at) {
      return true;
    }
    return false;
  }

  return (
    <AccessControl
      requiredPermissions={[
        {
          permission: "Reports",
          read: true,
        },
      ]}
      renderNoAccess={true}
    >
      <Title title={`${t("Reporting (monthly account manager)")} - ${targetData?.officeQTarget?.officeName ?? ""} (${reports?.from ?? "-"} to ${reports?.to ?? "-"})`
      } />

      {loading ? (
        <div style={{ height: "38vw" }} className="d-flex align-items-center justify-content-center">
          <LoadingIcon
            iconType="bars"
            color="#e55496"
            className="m-auto"
            height={"5vw"}
            width={"5vw"}
          />
        </div>

      ) : (
        <>
          <div className="row">
            <div className="col-md-4 mb-3">
              <OfficeTargetTable
                data={targetData?.officeTarget}
                tableTitle={t("Office")}
              />
            </div>
            <div className="col-md-4 mb-3">
              <OfficeTargetTable
                data={targetData?.officeQTarget}
                tableTitle={t("Office Q")}
              />
            </div>
            <div className="col-md-4 mb-3">
              <OMTargetTable data={targetData?.targets} tableTitle={reports?.amName} isForeign={targetData?.officeQTarget?.isForeign}/>
            </div>
            {!foreignOffice &&
            <div className="col-md-6">
              <VacanciesTable data={reports.vacancies} tableTitle={t("Vacancies")} />
            </div>
            }
            <div className="col-md-6">
              <VacanciesTable data={reports.foreignVacancies} isFroTable={true} tableTitle={t("Vacancies FRO")} />
            </div>
            <div className="col-md-6">
              <VisitsTable data={reports.visits} tableTitle={t("Visits")} />
              <div>
                <ProspectCallsTable
                  data={reports.prospectCalls}
                  tableTitle={t("Prospect call")}
                />
              </div>
            </div>
            <div className="col-md-6">
              <CooAgreementTable
                data={reports.cooAgreement}
                tableTitle={t("Cooperation agreement")}
              />
            </div>

          </div>
          <div className="row">
            <TableTitle title={t("Recruitment")} />
            <StartersTable
              data={reports.starters}
              view="om"
              tableTitle={t("Starters")}
            />
            <StoppersTable
              data={reports.stoppers}
              view="om"
              tableTitle={t("Stopper")}
            />
            <div className="row equal-cols" style={{zIndex:3, backgroundColor: 'white'}}>
              <Title title={t("Analysis")} />
              {authUser.role === OFFICE_MANAGER && analysisData?.confirmed_at &&
                <ValidationDetails validatedBy={analysisData?.am_name} validatedAt={analysisData?.confirmed_at} />
              }
              {authUser.role === AREA_MANAGER && analysisData?.om_confirmed_at &&
                <ValidationDetails validatedBy={analysisData?.om_name} validatedAt={analysisData?.om_confirmed_at} />
              }
              <div className="col-7 mt-2">
                <div className="row">
                  <div className="col-6">
                    <LabelWithTextAreaField
                      name="analysis"
                      handleChange={handleAnalysisFieldChange}
                      label={t("Make an analysis of your month!")}
                      value={analysisData.analysis}
                      isDisabled={authUser.role === ACCOUNT_MANAGER ? !canAct() : true}
                    />
                  </div>
                  <div className="col-6">
                    <LabelWithTextAreaField
                      name="smile_moments"
                      handleChange={handleAnalysisFieldChange}
                      label={t(`Share your "smile" moments with us!`)}
                      value={analysisData.smile_moments}
                      isDisabled={authUser.role === ACCOUNT_MANAGER ? !canAct() : true}
                    />
                  </div>
                  <div className="col-6">
                    <LabelWithTextAreaField
                      name="growth_points"
                      handleChange={handleAnalysisFieldChange}
                      label={t("Share your growth points with us")}
                      value={analysisData.growth_points}
                      isDisabled={authUser.role === ACCOUNT_MANAGER ? !canAct() : true}
                    />
                  </div>
                  <div className="col-6">
                    <LabelWithTextAreaField
                      name="thoughts_comments"
                      handleChange={handleAnalysisFieldChange}
                      label={t("Share your thoughts and comments with us")}
                      value={analysisData.thoughts_comments}
                      isDisabled={authUser.role === ACCOUNT_MANAGER ? !canAct() : true}
                    />
                  </div>
                </div>
              </div>
              <div className="col-5">
                <LabelWithTextAreaField
                  name="om_analysis"
                  handleChange={handleAnalysisFieldChange}
                  label={t("Feedback from Office Manager")}
                  value={analysisData.om_analysis}
                  isDisabled={authUser.role === OFFICE_MANAGER ? !canAct() : true}
                />
                <LabelWithTextAreaField
                  name="am_analysis"
                  handleChange={handleAnalysisFieldChange}
                  label={t("Area manager feedback")}
                  value={analysisData.am_analysis}
                  isDisabled={authUser.role === AREA_MANAGER ? !canAct() : true}
                />
              </div>
            </div>
            <div className="row py-4">
              <div className="col-md-4 align-self-center">
                <Link
                  to="/manage-reports"
                  className=" back-btn text-decoration-underline"
                >
                  {t("Back")}
                </Link>
              </div>
              {/* <AccessControl
                requiredPermissions={[
                  {
                    permission: "Daily turnover",
                    create: true,
                    update: true,
                  },
                ]}
                actions={true}
                strict={false}
              > */}
              <div className="col-md-8 d-flex justify-content-end align-items-end">
                {canAct() ? (
                  !loading ? (
                    <>
                      {/* The area manager closes the month off, so their validation waits until the
                          month has ended; the account manager and office manager confirm during it. */}
                      {(authUser.role !== AREA_MANAGER || !isCurrentMonth) && (
                        <Button
                          title={t("Validate")}
                          type="submit"
                          className="form-button shadow-none me-2"
                          handleClick={(e) => handleSubmit(e, true)}
                        />
                      )}
                      <Button
                        title={t("Save")}
                        type="submit"
                        className="form-button shadow-none"
                        handleClick={(e) => handleSubmit(e)}
                      />
                    </>
                  ) : (
                    <LoadingIcon
                      iconType="bars"
                      color="#ff4dae"
                      className="float-end"
                      width={"3vw"}
                      height={"3vw"}
                    />
                  )) : null
                }
              </div>
              {/* </AccessControl> */}
            </div>
          </div>
        </>
      )}
    </AccessControl>
  );
};

export default MonthlyReports;
